import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { behaviour } from 'constants/skus';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const SkuBehaviourSelect = ({
  label,
  variant,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  omitFields,
  asyncErrors,
  margin,
}) => {
  const [defaultValue, setDefaultValue] = useState('');
  const filterOptions = generateFilterOptions('start', 'label');
  useEffect(() => {
    if (value || value === '') {
      const defaultVal = behaviour.find((status) => status === value);
      if (defaultVal) {
        setDefaultValue(i18n.t(`skus.${defaultVal}`));
      } else {
        setDefaultValue('');
      }
    }
  }, [value, behaviour]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      label={label}
      id="behaviour"
      margin={margin}
      variant={variant}
      inputValue={defaultValue}
      filterOptions={filterOptions}
      onInputChange={(ev, val) => setDefaultValue(val || '')}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => setFieldValue(name, val || '')}
      getOptionLabel={(option) => i18n.t(`skus.${option}`)}
      options={behaviour.filter((value) => omitFields.indexOf(value))}
      getOptionSelected={(option, value) => option === value || ''}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
    />
  );
};

SkuBehaviourSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

SkuBehaviourSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  style: {},
  field: {},
  omitFields: [],
  label: 'Behaviour',
  variant: 'standard',
};

export default SkuBehaviourSelect;
